import { TField } from './isField';
import { TFieldInput } from './isFieldInput';

export function getFieldPlantHeight(
	field: TField | TFieldInput
): number | string {
	const { plantHeight } = field;
	return plantHeight || '-';
}
